import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RrhhComponent, DialogDataExampleDialog2Component } from './rrhh.component';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
// import { MatButtonModule, MatCheckboxModule, MatIconModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { RrhhService } from './rrhh.service';

import {HttpClientModule} from '@angular/common/http';
import {HttpModule} from '@angular/http';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatCheckboxModule, MatIconModule, MatInputModule, MatSlideToggleModule, MatToolbarModule } from '@angular/material';
import { FuseConfirmDialogModule } from '@fuse/components';
const routes = [
  {
      path     : 'rrhh',
      component: RrhhComponent
  }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatButtonModule,
    MatCheckboxModule,
    SweetAlert2Module,
    MatIconModule,
    TranslateModule,
    AgGridModule.withComponents([]),
    FuseSharedModule,
    HttpClientModule, HttpModule,
    FuseConfirmDialogModule
  ],
  exports     : [
    RrhhComponent
],
  declarations: [RrhhComponent, DialogDataExampleDialog2Component],
  providers: [RrhhService],
  entryComponents: [DialogDataExampleDialog2Component],
})
export class RrhhModule { }
